import { computed, makeObservable, toJS } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import reports from 'modules/reports/store/collections/reports'
import Report, { type Variable } from 'modules/reports/store/models/Report'

export const VARIABLE_TYPES = {
  text: 'text',
  date: 'date',
  team: 'team',
}

interface IDashboard {
  [key: string]: any
}

class Dashboard extends Model<IDashboard> {
  constructor(attr: IDashboard = {}) {
    super(attr)
    makeObservable(this, {
      title: computed,
      description: computed,
      reports: computed,
      isReadonly: computed,
      variables: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/reports/dashboard'
  }

  get title(): string {
    return this.attributes.title
  }

  get description(): string {
    return this.attributes.description
  }

  get reports(): Report[] {
    return reports.filter({
      dashboard_id: this.id,
    })
  }

  get variables(): Variable[] {
    const dashboardObj = this.toJS()

    if (!dashboardObj.variables) {
      return []
    }

    return toJS(dashboardObj.variables)
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }
}

export default Dashboard
